import { ProjectData } from 'src/app/entities/project-data.entity';
import { ProjectDataPerimetro } from '../entities/project-data-perimetro.entity';
import { ProjectDataScheme } from '../entities/project-data-scheme';
import { Utils } from '../utils.module';
import { CleanPerimeters } from './clean-perimeters';
import { Scheme2Component } from '../builder/scheme2/scheme2.component';
import { debug } from 'console';
import { Input, Output, RendererFactory2 } from '@angular/core';

export const LastVersion = 1;

export class ParseProjectVersion {

	private errors: string[] = [];

	private versions: any[];

	private projectNew: ProjectData;

	// Convierte un proyecto a la versión más actual.
	parse = function (project: ProjectData): ProjectData {

		// Comprobar que no es null.
		if (!project) {
			this.errors.push('>> PARSER:: Parámetro "project" es null.');
			console.log('>> PARSER:: Parámetro "project" es null.');
			return null;
		}

		// console.log(`>> PARSEANDO PROYECYO '${project.nombre}' - ID '${project._id}'`);

		// Clonar.
		this.projectNew = JSON.parse(JSON.stringify(project));
		// Comprobar si tiene versión.
		if (!this.projectNew.version) {
			// Pasar por toda la cascada.
			this.projectNew.version = 0;
		}

		//if (this.projectNew.renderer === Utils.SCHEME2) this.adjustSCHEME2();
		if (this.projectNew.renderer === Utils.SCHEME2) {
			let clean = new CleanPerimeters();
			this.valoresCentrado = this.adjustSCHEME2();

			this.projectNew.perimetro = clean.clean(this.projectNew.perimetro);
			this.projectNew.scheme = new ProjectDataScheme();
			this.projectNew.valoresCentrado = this.valoresCentrado;

			// Calcular nuevos valoresd de centrado
			this.projectNew.scheme.x = (-1)* this.valoresCentrado.placement2D.margeX + (window.innerWidth / 2);
			this.projectNew.scheme.y = (-1)*this.valoresCentrado.placement2D.margeY + (window.innerHeight / 2);
		}


		switch (this.projectNew.version) {
			case 0: this.version_00to01();
		}

		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(this.projectNew));
		return this.projectNew;
	}

	// Calcula el centro de los schemas 2d y 3D (en base al centro de la BoundaryBox que engloba todos los perímetros del proyecto actual)
	computeCenter = function (project: ProjectData): any {

		// Comprobar que no es null.
		if (!project) {
			this.errors.push('>> PARSER:: Parámetro "project" es null.');
			console.log('>> PARSER:: Parámetro "project" es null.');
			return null;
		}

		this.projectNew = JSON.parse(JSON.stringify(project));
		let clean = new CleanPerimeters();
		var valoresCentrado = this.adjustSCHEME2();

		return valoresCentrado;
	}

	// Reajuste de los parímetros para que se situen en el centro del mapa.
	// Solo se cumple con los proyectos de tipo Esquema.
	adjustSCHEME2 = function () {
		// Situar en el centro del plano.
		//this.projectNew.scheme = new ProjectDataScheme(); // x:-10000, y:-10000, scale:1

		// BoundaryBox para schema2D (funciona con coordenadas x,y)
		let rect2D = { up: -99999, bottom: 99999, left : 99999, right: -99999 };

		// BoundaryBox para schema3D (funciona con coordenadas longitud,latitud)
		let rect3D = { up: -99999, bottom: 99999, left : 99999, right: -99999 };

		let camera2D = {margeX: 0, margeY: 0, rect2D: {}}
		let camera3D = {margeLng: 0, margeLat: 0, rect3D: {}}

		let centerPlacement = { placement2D :{}, placement3D: {}, applyDefault: true };

		let bApplyDefault = true;
		let iNumOfChanges = 0;

		for (let ip = 0; ip < this.projectNew.perimetro.length; ip++) {

			let p = this.projectNew.perimetro[ip];
			for (let ic = 0; ic < p.coordenadas.length; ic++) {
				let c = p.coordenadas[ic];

				if (c.vy > rect2D.up) 		{ rect2D.up = c.vy; iNumOfChanges+=1;}
				if (c.vy < rect2D.bottom) 	{ rect2D.bottom = c.vy; iNumOfChanges+=1;}
				if (c.vx > rect2D.right) 	{ rect2D.right = c.vx; iNumOfChanges+=1;}
				if (c.vx < rect2D.left) 	{ rect2D.left = c.vx; iNumOfChanges+=1;}


				if (c.lat > rect3D.up) 		{ rect3D.up = c.lat; iNumOfChanges+=1;}
				if (c.lat < rect3D.bottom)  { rect3D.bottom = c.lat; iNumOfChanges+=1;}
				if (c.lng > rect3D.right) 	{ rect3D.right = c.lng; iNumOfChanges+=1;}
				if (c.lng < rect3D.left) 	{ rect3D.left = c.lng; iNumOfChanges+=1;}
			}
		}

		// Si tenemos como mínimo un perímetro, no aplicamos la transformación inicial.
		if( iNumOfChanges ) {
			bApplyDefault = false;
		}

		// Calculamos el punto medio de la BB (2D)
		const y = (rect2D.up - rect2D.bottom) / 2;
		const x = (rect2D.right - rect2D.left ) / 2;

		// Aplicamos los desplazamientos necesario para que las coordenadas calculadas indiquen el centro de la BB
		camera2D.margeY = (y + rect2D.bottom);
		camera2D.margeX = (x + rect2D.left);
		camera2D.rect2D = rect2D;

		// Calculamos el punto medio de la BB (3D)
		const lat = ( rect3D.up - rect3D.bottom) / 2;
		const lng = ( rect3D.right - rect3D.left  ) / 2;

		// Aplicamos los desplazamientos necesario para que las coordenadas calculadas indiquen el centro de la BB
		camera3D.margeLat = (lat + rect3D.bottom) * (-100.0);
		camera3D.margeLng = (lng + rect3D.left) * 100.0;

		camera3D.rect3D = rect3D;

		centerPlacement.placement2D = camera2D;
		centerPlacement.placement3D = camera3D;
		centerPlacement.applyDefault = bApplyDefault;

		return centerPlacement;


	//	console.log(JSON.stringify(rect));
		// El centro del plano está dentro del rectangulo no seguir.
		// Para evitar estar modificando un proyecto continuamente.
		//if ((rect.up > 0.0 && rect.bottom < 0.0) && (rect.left < 0.0 && rect.right > 0.0)) {
		//	console.log('No se resituan los perímetros.');
		//	return;
		//}

		// Se obtienen las medias, solo se tiene en cuenta '0.0' y lat se suma y lng se resta.

		// let margeLat = Math.abs(rect.up - rect.bottom) / 2;
		// console.log("margeLat, último 	X", margeLat)
		// let margeLng = Math.abs(rect.left - rect.right) / 2;
		// console.log("margeLng, último Y", margeLng)

		//console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
		//console.log(`margeLat:${margeLat} margeLng:${margeLng}`);

		// Obtener desplazamiento para situar el centro del rectangualo global en el punto '0.0'.
		// No se modifica toda la cifra solo los digitos n.0, para que guarde igualdad con la grid.
		//let maxUp = rect.up; //Math.trunc(rect.up * 100) / 100;
		//let maxLeft = Math.trunc(rect.left * 100) / 100;
		//console.log(`maxUp:${maxUp} maxLeft:${maxLeft}`);


		// Ejecutar cuando está guardado en el listado de proyectos o cuando se cambia al 3D
		// console.log('#### CAMBIANDO ########');
		// for (let ip = 0; ip < this.projectNew.perimetro.length; ip++) {
		// 	let p = this.projectNew.perimetro[ip];
		// 	// console.log(p)
		// 	for (let ic = 0; ic < p.coordenadas.length; ic++) {
		// 		let _debug = (p.coordenadas[ic].lng - rect.left) - margeLng;
		// 		// console.log("DEBUGGGG   "+_debug);
		// 		// p.coordenadas[ic].lng = (p.coordenadas[ic].lng - rect.left) - margeLng;
		// 		// p.coordenadas[ic].lat = (p.coordenadas[ic].lat - rect.up) + margeLat;
		// 	}
		// }

		//console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
	}

	// Versionados.
	version_00to01 = function () {
		// Marcar como versión 1.
		this.projectNew.version = 1;
	}
	static adjustSCHEME2: any;
}


/*
coordenadas: [{lat: -0.207, lng: 0.596, vx: 10596, vy: 10207, id: "PR000P0000"},…]
0: {lat: -0.207, lng: 0.596, vx: 10596, vy: 10207, id: "PR000P0000"}
id: "PR000P0000"                  lat: -0.207    lng: 0.596
vx: 10596 vy: 10207
1: {lat: -0.301, lng: 0.522, vx: 10522, vy: 10301, id: "PR000P0001"}
id: "PR000P0001"					lat: -0.301  lng: 0.522
vx: 10522 vy: 10301
*/
